import React from "react";

const YoutubeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none">
    <path
      fill="red"
      d="M10.064 2.498H10.176c1.027.004 6.233.042 7.637.42a2.51 2.51 0 0 1 1.768 1.774c.127.474.215 1.105.277 1.753l.011.13c.01.109.02.217.027.325l.01.13c.082 1.143.092 2.212.093 2.446v.094a39.31 39.31 0 0 1-.103 2.576l-.01.13-.01.13c-.063.716-.155 1.426-.295 1.948a2.509 2.509 0 0 1-1.768 1.774c-1.45.39-6.961.418-7.726.42h-.176c-.386-.001-1.985-.009-3.66-.066l-.213-.008-.107-.004-.215-.008-.213-.01c-1.387-.06-2.71-.16-3.318-.324a2.509 2.509 0 0 1-1.768-1.774c-.14-.522-.232-1.232-.294-1.948l-.011-.13-.01-.13A39.25 39.25 0 0 1-.001 9.6v-.154c.002-.268.013-1.198.08-2.223l.008-.128.005-.065.01-.13.027-.325.011-.13c.062-.648.15-1.279.277-1.753a2.51 2.51 0 0 1 1.768-1.774c.608-.164 1.93-.264 3.318-.325l.213-.009.215-.008.107-.004.214-.008C7.819 2.51 9.32 2.5 9.822 2.5h.242ZM8 6.512v6.022l5.196-3.01-5.196-3.012Z"
    />
  </svg>
);
export default YoutubeIcon;
